<ldw-node-value-list-view [list]="list"></ldw-node-value-list-view>
